import CronAdapter from './base';

export default class Task extends CronAdapter {
  modelNamePlural = 'tasks';
}
